import { User } from '@auth0/auth0-react'
import { UserRole } from '@/types'

const AUTH0_NAMESPACE = 'https://trustytool.org'

const useAccessTokenReader = () => {
  const getCompanyId = (user: User | undefined) => {
    const companyId = user?.[`${AUTH0_NAMESPACE}/company`]
    return companyId
  }

  const getAllRoles = (user: User | undefined) => {
    if (!user) return []

    // Check if admin
    // https://community.auth0.com/t/how-to-add-roles-and-permissions-to-the-id-token-using-actions/84506
    return user?.[`${AUTH0_NAMESPACE}/roles`] || []
  }

  const isAdminFunc = (user: User | undefined) => {
    if (!user) return false
    const allRoles = getAllRoles(user)
    return allRoles.includes(UserRole.ADMIN)
  }

  const isDashboardUserFunc = (user: User | undefined) => {
    if (!user) return false
    const allRoles = getAllRoles(user)
    return allRoles.includes(UserRole.DASHBOARD_USER)
  }

  const isDemoUserFunc = (user: User | undefined) => {
    if (!user) return false
    const allRoles = getAllRoles(user)
    return allRoles.includes(UserRole.DEMO_USER)
  }

  const isLeadUserFunc = (user: User | undefined) => {
    if (!user) return false
    const allRoles = getAllRoles(user)
    return allRoles.includes(UserRole.LEAD_USER)
  }

  const getDefaultResultId = (user: User | undefined): number | undefined => {
    const defaultResultId = user?.[`${AUTH0_NAMESPACE}/defaultResultId`]
    return defaultResultId
  }

  return {
    getAllRoles,
    isAdminFunc,
    isDashboardUserFunc,
    getCompanyId,
    isDemoUserFunc,
    isLeadUserFunc,
    getDefaultResultId,
  }
}

export default useAccessTokenReader
